import { render, staticRenderFns } from "./CombatStatsWidget.vue?vue&type=template&id=0e911d39&scoped=true"
import script from "./CombatStatsWidget.vue?vue&type=script&lang=js"
export * from "./CombatStatsWidget.vue?vue&type=script&lang=js"
import style0 from "./CombatStatsWidget.vue?vue&type=style&index=0&id=0e911d39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e911d39",
  null
  
)

export default component.exports